import { render, staticRenderFns } from "./table-chars.vue?vue&type=template&id=6212e801&scoped=true"
import script from "./table-chars.vue?vue&type=script&lang=ts"
export * from "./table-chars.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6212e801",
  null
  
)

export default component.exports